import type { IconDefinition } from '../index.tsx';

export const iconHelpCircle: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconHelpCircle',
  icon: [
    16,
    16,
    [],
    '',
    'M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8 5C7.17157 5 6.5 5.67157 6.5 6.5V7H4.5V6.5C4.5 4.567 6.067 3 8 3C9.933 3 11.5 4.567 11.5 6.5C11.5 8.433 9.933 10 8 10H7V8H8C8.82843 8 9.5 7.32843 9.5 6.5C9.5 5.67157 8.82843 5 8 5ZM9 11V13H7V11H9Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
